import { Box } from '@mui/material'
import { Stack } from '@mui/material'
import sortBy from 'lodash/sortBy'
import React, { FC } from 'react'

import { UserItemSerialDetailFragment } from '@/clients/utoniq-core/schema'
import { TicketSelect } from '@/components/organisms'

type TicketContainerProps = {
  serials?: UserItemSerialDetailFragment[]
  selectedSerials: string[]
  throughTicketIndex?: number
  onSelectSerial: (serialId: string) => void
}

export const TicketContainer: FC<TicketContainerProps> = ({
  serials,
  throughTicketIndex,
  onSelectSerial,
  selectedSerials,
}) => {
  return (
    <Box>
      <Stack spacing={2}>
        {sortBy(serials, serial => serial.formattedSerialNumber).map(serial => (
          <TicketSelect
            key={serial.serialId}
            selected={
              selectedSerials.findIndex(id => id === serial.serialId) >= 0
            }
            throughTicketIndex={throughTicketIndex}
            serial={serial}
            onSelect={onSelectSerial}
          />
        ))}
      </Stack>
    </Box>
  )
}
